import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FolderTreeEntryComponent } from './FolderTreeEntry.component';

export const FolderTreeEntryModuleExports = [FolderTreeEntryComponent];

@NgModule({
    imports: [CommonModule],
    declarations: [...FolderTreeEntryModuleExports],
    exports: [...FolderTreeEntryModuleExports],
    providers: []
})
export class FolderTreeEntryModule {}
